var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading_background"}},[_c('div',{attrs:{"id":"loading_circle_background"}},[_c('circle2',{staticStyle:{"top":"8px","left":"8px","position":"absolute","width":"32px","height":"32px","border-color":"white white #00a0e9 #00a0e9","border-width":"4px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }